import {
  CLAIM,
  CLAIM_STATUS,
  PARTIES_CLAIM_STATUS,
  VICTIM,
} from 'containers/data-structure';
import { every, get, isEmpty, isNil, uniqueId } from 'lodash';
import moment from 'moment-timezone';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import {
  CHOICE,
  INJURY_POST,
  INJURY_POST_DECEASED_SAGIS,
  VICTIM_ITT_AVAILABILITY,
  INJURY_POST_DECEASED,
  INJURY_POST_INJURED,
} from 'containers/PreOpeningPage/constants';
import * as featureService from 'features/fflip-helpers';
import messages from 'containers/PreOpeningPage/messages';
import { FEATURES } from 'features/features';
import {
  isClaimClosOrNoAction,
  shouldDisplayEditButton,
} from 'containers/RecapManagerPage/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { getTheLatestEvaluationObject } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
import { translate } from 'containers/services/translate';
import { OTHER_PROFESSION } from 'containers/RecapManagerPage/constants';
import validate from 'containers/services/validateForm';
import {
  FraudInfoType,
  VictimType,
  VehiculeType,
  BeneficiaryType,
} from 'typings/globalTypes';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { removeWhiteSpaceFromString } from 'services/utils';

export const isObjectAttributesEmpty = (obj: any) => {
  // check if all attributes are null/empty
  return every(obj, v => !v);

  //upgrade: check if at least 1 is null / empty
};
export const ageValidation = (beneficiaryType: any, value: any) => {
  return value !== '' &&
    ((beneficiaryType === '3' && Number(value) <= 12) || value < 0)
    ? true
    : false;
};
export const renderStatusDecisionParties = (status: string) => {
  switch (status) {
    case PARTIES_CLAIM_STATUS.REJECTED:
      return 'Rejeté';
    case PARTIES_CLAIM_STATUS.VALIDATED:
      return 'Confirmé';
  }
};
export const minorVictimQualityAyantDroitList = (
  qualityAyantDroitList: any,
) => {
  return qualityAyantDroitList.filter(
    (element: { ItemKey: string }) =>
      element.ItemKey !== '3' &&
      element.ItemKey !== '1' &&
      element.ItemKey !== '4' &&
      element.ItemKey !== '6',
  );
};

export const isVictimIncludedInJudiciarySteps = (victim: VictimType) =>
  !isEmpty(get(victim, 'expertiseJudgementAddVictims', []));

export const getVictimFromSagisInfo = (
  victimCorpoKey: any,
  victimSagis: any,
) => {
  return victimSagis?.find((el: any) => el.VictimKey === victimCorpoKey);
};

export const oppositionVictimValue = (victim: any) => {
  return get(victim, [VICTIM.OPPOSITION], '') === false
    ? 0
    : get(victim, [VICTIM.OPPOSITION], '') === true
    ? 1
    : get(victim, [VICTIM.OPPOSITION], '');
};
export const townVictimValue = (town: any, citiesListing: any) => {
  if (citiesListing) {
    return get(
      citiesListing.find(
        (el: any) => el.ItemDescription?.toUpperCase() === town?.toUpperCase(),
      ),
      'ItemKey',
      null,
    );
  }
  return {};
};

export const formatVictimFromSagisBody = (
  sagisVictimInfo: any,
  listings: any,
  value: any,
) => {
  return {
    isFromSagis: true,
    victimKey: get(sagisVictimInfo, 'victimKey', ''),
    firstName: get(sagisVictimInfo, 'victimFirstName', ''),
    lastName: get(sagisVictimInfo, 'victimLastName', ''),
    cin: get(sagisVictimInfo, 'CIN', ''),
    telephoneNumber: get(sagisVictimInfo, 'telephoneNumber', ''),
    procedureId: '',
    damageType: '',
    profession: '',
    city: String(
      townVictimValue(
        get(sagisVictimInfo, 'Town', ''),
        get(listings, 'villes', []),
      ),
    ) as any,

    address: get(sagisVictimInfo, 'Complement', ''),
    itt: get(sagisVictimInfo, 'itt', ''),
    claimId: get(value, 'claim.id', ''),
    isExcluded: '',
    workAccidentId: '',
    classKey: get(sagisVictimInfo, 'classVictim', ''),
    injuryPostKey: '',
    dateOfBirth: dateStringToLocalDate(
      get(sagisVictimInfo, 'victimBirthDate', null),
    ) as any,
    qualityKey: get(sagisVictimInfo, 'qualityVictim', ''),
    opposition: (get(sagisVictimInfo, 'oppositionInd', '') === 'Y'
      ? 1
      : 0) as any,
  };
};
export const extractOpposingParties = (offredRisks: any) => {
  return get(
    offredRisks?.find((el: any) => el.riskName === rcCoporeal),
    'opposingParties',
  );
};

export const getAgeBeneficiary = (
  date: string,
  lossDate: string | undefined,
  ageBeneficiary: any,
) => {
  if (!isNil(date)) {
    const today = lossDate ? new Date(lossDate) : new Date();
    const dateOfBirth = new Date(date);

    let age = today.getFullYear() - dateOfBirth.getFullYear();

    const monthDifference = today.getMonth() - dateOfBirth.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < dateOfBirth.getDate())
    ) {
      age--;
    }
    return isNaN(age) ? '' : age;
  } else if (!isNil(ageBeneficiary)) {
    return ageBeneficiary;
  } else {
    return '';
  }
};

export const getBirthYearBeneficiary = (
  lossDate: string | undefined,
  ageBeneficiary: any,
) => {
  const today = lossDate ? new Date(lossDate) : new Date();

  let year = today?.getFullYear() - ageBeneficiary;
  return year;
};

export const checkUniqCinVictim = (
  victims: any,
  cinVictims: string,
  uniqIdVictim: number,
  lossDate: any,
) => {
  const victimsWithAge = victims.map((el: any) => ({
    ...el,
    age: Number(
      moment(lossDate)
        .diff(get(el, VICTIM.DATE_OF_BIRTH), 'years', true)
        .toFixed(2),
    ),
  }));
  const allCinVictims = victimsWithAge
    .filter((it: any) => it.age > 18)
    .filter(
      (element: any) =>
        element.cin === cinVictims &&
        (!isNil(get(element, 'uniqueId', null))
          ? element.uniqueId != uniqIdVictim
          : element.id != uniqIdVictim),
    )
    .map((el: any) => get(el, 'cin'))
    .filter((item: any) => item != '');
  if (allCinVictims.includes(cinVictims)) {
    return true;
  } else {
    return false;
  }
};

export const isMinorVictim = (victim: any, lossDate: any) => {
  return (
    Number(
      moment(lossDate)
        .diff(
          moment(get(victim, VICTIM.DATE_OF_BIRTH)).format('YYYY-MM-DD'),
          'years',
          true,
        )
        .toFixed(2),
    ) < 18
  );
};

export const isUniqueCinVictims = (victims: any, lossDate: any) => {
  let cinSet = new Set();
  let duplicates: any = [];
  const majorVictims = victims.filter(
    (el: any) =>
      Number(
        moment(lossDate)
          .diff(get(el, VICTIM.DATE_OF_BIRTH), 'years', true)
          .toFixed(2),
      ) > 18,
  );
  majorVictims.forEach((victim: any) => {
    let cin = victim.cin;
    if (cinSet.has(cin)) {
      duplicates.push(cin);
    } else {
      cinSet.add(cin);
    }
  });

  return isEmpty(duplicates);
};

export const isUniqueCinAddedVictims = (
  allVictims: VictimType[],
  victims: VictimType[],
  lossDate: Date,
) => {
  let cinSet = new Set();
  let duplicates: any = [];
  const majorVictims = allVictims.filter(
    (el: any) =>
      Number(
        moment(lossDate)
          .diff(get(el, VICTIM.DATE_OF_BIRTH), 'years', true)
          .toFixed(2),
      ) > 18,
  );
  majorVictims.forEach((victim: any) => {
    let cin = victim.cin;
    cinSet.add(cin);
  });
  const majorAddedVictims = victims.filter(
    (el: any) =>
      Number(
        moment(lossDate)
          .diff(get(el, VICTIM.DATE_OF_BIRTH), 'years', true)
          .toFixed(2),
      ) > 18,
  );
  majorAddedVictims.forEach((victim: any) => {
    let cin = victim.cin;
    if (cinSet.has(cin)) {
      duplicates.push(cin);
    } else {
      cinSet.add(cin);
    }
  });

  return isEmpty(duplicates);
};
export const formatClaimToPreOpen = (
  claim: any,
  listings: any,
  dahirAmount?: any,
) => {
  const rcCoporealRisk = get(claim, 'offeredRisks', []).find(
    (el: any) => el.riskName === rcCoporeal,
  );

  return {
    claim: !isEmpty(claim)
      ? {
          ...claim,
          isClosOrNoAction: isClaimClosOrNoAction(claim),
          [CLAIM.CLAIM_NUMBER]: get(claim, 'code'),
          [CLAIM.FIRST_NAME]: get(claim, 'clientFirstName', ''),
          [CLAIM.LAST_NAME]: get(claim, 'clientLastName', ''),
          [CLAIM.REGISTRATION_NUMBER]: get(claim, 'registrationNumber'),
          [CLAIM.LOSS_HOUR]: get(claim, 'lossTime'),
          [CLAIM.LOSS_LOCATION]: get(listings, 'villes', []).find((e: any) =>
            e.ItemDescription.includes(
              get(claim, `lossLocation`) &&
                get(claim, `lossLocation`).toUpperCase(),
            ),
          )?.ItemKey,
          [CLAIM.COUNTRY_ID]: get(listings, 'villes', []).find((e: any) =>
            e.ItemDescription.includes(
              get(claim, `lossLocation`) &&
                get(claim, `lossLocation`).toUpperCase(),
            ),
          )?.ItemGroup,
          [CLAIM.TOTAL_INJURED_VICTIMS]: get(claim, 'victims', []).filter(
            (v: any) => String(v.injuryCode) !== INJURY_POST_DECEASED_SAGIS,
          ).length,
          [CLAIM.TOTAL_DECEASED_VICTIMS]: get(claim, 'victims', []).filter(
            (v: any) => String(v.injuryCode) === INJURY_POST_DECEASED_SAGIS,
          ).length,
          [CLAIM.MANAGEMENT_MODE]: get(rcCoporealRisk, 'managementModeCode'),
          managementModeKey: get(rcCoporealRisk, 'managementModeCode'),
          [CLAIM.SCALE_CASE_KEY]: get(rcCoporealRisk, 'scaleCaseCode'),
          [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: get(
            rcCoporealRisk,
            'circumstanceCode',
          ),
          [CLAIM.ACCIDENT_CIRCONSTANCE]: get(rcCoporealRisk, 'circumstance'),
          [CLAIM.RESPONSABILITY_KEY]: get(
            rcCoporealRisk,
            'responsibilityRateCode',
          ),
        }
      : {},
    driver: get(claim, 'driver', {}),
    vehicule: !isEmpty(get(rcCoporealRisk, 'opposingParties', []))
      ? get(rcCoporealRisk, 'opposingParties', []).map((opposingParty: any) => {
          return {
            firstName: get(opposingParty, 'firstName'),
            lastName: get(opposingParty, 'lastName'),
            brand: '',
            partKey: get(opposingParty, 'partyKey'),
            opposingParty: get(opposingParty, 'insuranceCompanyCode'),
            registrationNumber: get(opposingParty, 'registrationNumber'),
            isFromSagis: true,
          };
        })
      : get(claim, 'vehicule', {}),
    victims: get(claim, 'victims', []).map((v: any) => {
      return {
        ...v,
        uniqueId: uniqueId(),
        [VICTIM.CIN]: v.CIN,
        [VICTIM.FIRST_NAME]: v.victimFirstName,
        [VICTIM.LAST_NAME]: v.victimLastName,
        [VICTIM.VICTIM_KEY]: v.VictimKey,
        [VICTIM.TELEPHONE_NUMBER]: v.telephoneNumber,
        [VICTIM.DAMAGE_TYPE]: '',
        [VICTIM.ITT_AVAILABILITY]: !isNil(
          get(
            getTheLatestEvaluationObject(String(v.VictimKey), dahirAmount),
            'rateITT',
            null,
          ),
        )
          ? VICTIM_ITT_AVAILABILITY.AVAILABLE
          : null,
        [VICTIM.ITT]: get(
          getTheLatestEvaluationObject(String(v.VictimKey), dahirAmount),
          'rateITT',
          null,
        ),
        [VICTIM.DATE_OF_BIRTH]: dateStringToLocalDate(v.victimBirthDate),
        [VICTIM.QUALITY_KEY]: v.qualityVictim,
        [VICTIM.CLASS_KEY]: v.classVictim,
        [VICTIM.PROFESSION_TYPE]: String(v.professionCode),
        [VICTIM.WORK_ACCIDENT_ID]: v.isWorkAccident ? 1 : 2,
        [VICTIM.OPPOSITION]: v.oppositionInd === 'Y' ? 1 : 0,
        [VICTIM.ADDRESS]: v.complement,
        [VICTIM.CITY]: townVictimValue(v.Town, get(listings, 'villes', [])),
        [VICTIM.IS_EXCLUDED]: v.isCoverExcluded ? CHOICE.YES : CHOICE.NO,
        [VICTIM.INJURY_POST_KEY]:
          String(v.injuryCode) === INJURY_POST_DECEASED_SAGIS
            ? INJURY_POST.DECEASED[0]
            : INJURY_POST.INJURED[0],
        isModified: featureService.hasFeature(FEATURES.BASIC_MANAGEMENT),
        victimPhoneNumber: v.telephoneNumber,
        victimProfessionCode: v.professionCode,
        beneficiaries: !isNil(v.nextOfKins)
          ? v.nextOfKins.map((el: any) => {
              const nameParts = el.fullName.split(' ');
              return {
                ...el,
                firstName: get(nameParts, '[0]', ' '),
                lastName: get(
                  nameParts,
                  `[${nameParts.length - 1 != 0 ? nameParts.length - 1 : -1}]`,
                  ' ',
                ),
                nextOfKinKey: el.nextOfKinKey,
                age: el.age,
                beneficiaryType: el.qualityCode,
                handicapIndicator: el.handicapIndicator === 'Y' ? true : false,
                dependentIndicator:
                  el.dependentIndicator === 'Y' ? true : false,
                funeralFees: el.funeralFees,
                isFromSagis: true,
              };
            })
          : [],
      };
    }),
    documents: get(claim, 'documents', []),
    opposingParty: !isEmpty(get(rcCoporealRisk, 'opposingParties', []))
      ? {
          hasMaterialDammage: 'YES',
          vehicules: get(rcCoporealRisk, 'opposingParties', []).map(
            (opposingParty: any) => {
              return {
                firstName: get(opposingParty, 'firstName'),
                lastName: get(opposingParty, 'lastName'),
                brand: '',
                partKey: get(opposingParty, 'partyKey'),
                opposingParty: get(opposingParty, 'insuranceCompanyCode'),
                registrationNumber: get(opposingParty, 'registrationNumber'),
                isFromSagis: true,
              };
            },
          ),
        }
      : {
          ...get(claim, 'opposingParty', {
            hasMaterialDammage: null,
            vehicules: [],
          }),
          isModified: featureService.hasFeature(FEATURES.BASIC_MANAGEMENT),
        },
  };
};
export const checkClassVictim = (
  dateOfBirth: any,
  lossDate: string,
  classKey: string,
) => {
  if (
    (Number(
      moment(lossDate)
        .diff(dateOfBirth, 'years', true)
        .toFixed(2),
    ) < 18 &&
      classKey != '0' &&
      classKey != '') ||
    (Number(
      moment(lossDate)
        .diff(dateOfBirth, 'years', true)
        .toFixed(2),
    ) > 18 &&
      classKey != '' &&
      classKey === '0')
  ) {
    return true;
  } else {
    return false;
  }
};

export const checkVictimAge = (dateOfBirth: any, lossDate: any) => {
  const age = Number(
    moment(lossDate)
      .diff(dateOfBirth, 'years', true)
      .toFixed(2),
  );
  if (Number(age) < 0) {
    return true;
  } else {
    return false;
  }
};
export const checkVictimsAge = (victims: any, lossDate: any) => {
  const victimList = victims.map((el: any) => {
    const dateOfBirth = get(el, VICTIM.DATE_OF_BIRTH);
    return checkVictimAge(dateOfBirth, lossDate);
  });
  return victimList.includes(true);
};

export const checkClassVictims = (victims: any, lossDate: string) => {
  const formattedVictims = victims.map((el: any) => {
    if (
      (Number(
        moment(lossDate)
          .diff(el.dateOfBirth, 'years', true)
          .toFixed(2),
      ) < 18 &&
        el.classKey != '' &&
        el.classKey != '0') ||
      (Number(
        moment(lossDate)
          .diff(el.dateOfBirth, 'years', true)
          .toFixed(2),
      ) > 18 &&
        (el.classKey === '' || el.classKey === '0'))
    ) {
      return true;
    } else {
      return false;
    }
  });
  return formattedVictims.includes(true);
};

export const areAllVictimsGenderFilled = (victims: VictimType[]) => {
  return victims.every(
    victim => !isEmpty(victim.gender) && !isNil(victim.gender),
  );
};
export const isAllVictimFulledEligibility = (
  victims: VictimType[],
  transactionEligibilityState: any,
) => {
  const mappedtransactionEligibilityState = transactionEligibilityState.map(
    (item: any) => item.id,
  );
  const filtredVictimsWithVictimKey = victims.filter(
    (el: VictimType) => el.victimKey != '' && !isNil(el.victimKey),
  );
  return (
    filtredVictimsWithVictimKey.filter(
      (el: any) =>
        mappedtransactionEligibilityState.includes(el.id) ||
        !isEmpty(el.eligibilityTransaction),
    ).length != filtredVictimsWithVictimKey.length
  );
};

export const transactionVictimEligible = (victims: VictimType[]) => {
  return !isEmpty(
    victims.filter(
      (item: any) =>
        get(item, 'eligibilityTransaction.[0].eligibility') &&
        isEmpty(item.transactions),
    ),
  );
};
export const isVictimEligibility = (victims: VictimType[]) => {
  return victims
    .filter((el: VictimType) => el.victimKey != '' && !isNil(el.victimKey))
    .some(
      (el: any) =>
        isNil(get(el, 'eligibilityTransaction[0].id', null)) ||
        isEmpty(el.eligibilityTransaction),
    );
};

export const getVictimInfoById = (policyInfo: any, victimId: number) => {
  const claimInfo = get(policyInfo, 'corporeal', []).find(
    (el: any) => el.status === CLAIM_STATUS.VALIDATED,
  );
  return get(claimInfo, 'victims', []).find((el: any) => el.id === victimId);
};

export const formatVictimToMigration = (
  sagisVictims: any,
  readInfoSagis: any,
  corporealVictims: any,
  listings: any,
  selectedIndex: any,
) => {
  if (isEmpty(sagisVictims) || !readInfoSagis) {
    return get(corporealVictims, 'victims', []);
  }

  const victimKeys = get(corporealVictims, 'victims', []).map(
    (el: any) => el?.victimKey,
  );

  const formattedCorporealVictims = get(corporealVictims, 'victims', []).map(
    (el: any, index: number) => {
      const victimSagisInfo = getVictimFromSagisInfo(
        get(el, 'victimKey'),
        sagisVictims,
      );

      if (
        index !== selectedIndex &&
        !el.isModified &&
        !isEmpty(victimSagisInfo)
      ) {
        return {
          ...el,
          cin: get(victimSagisInfo, 'CIN'),
          lastName: get(victimSagisInfo, 'victimLastName'),
          firstName: get(victimSagisInfo, 'victimFirstName'),
          dateOfBirth: get(victimSagisInfo, 'victimBirthDate'),
          telephoneNumber: get(victimSagisInfo, 'telephoneNumber'),
          qualityKey: String(get(victimSagisInfo, 'qualityVictim')),
          classKey: get(victimSagisInfo, 'classVictim'),
          opposition: get(victimSagisInfo, 'oppositionInd') === 'Y' ? 1 : 0,
          city: townVictimValue(
            get(victimSagisInfo, 'Town'),
            get(listings, 'villes', []),
          ),
          address: get(victimSagisInfo, 'Complement'),
        };
      }

      return { ...el };
    },
  );

  const formattedSagisVictims = sagisVictims
    .filter((el: any) => !victimKeys.includes(el?.VictimKey))
    .map((el: any) => ({
      ...el,
      isFromSagis: true,
      victimKey: el.VictimKey,
    }));

  return [...formattedCorporealVictims, ...formattedSagisVictims];
};

export const shouldDisableInput = (
  disableInput?: boolean,
  isCourtManagerBasicManagement?: boolean,
  valueInput?: any,
  contraintValue?: any,
  AllowEmptyValue?: any,
) => {
  if (
    disableInput ||
    (isCourtManagerBasicManagement &&
      !isNil(valueInput) &&
      ((valueInput &&
        !AllowEmptyValue &&
        !isEmpty(valueInput.toString().replace(' ', ''))) ||
        contraintValue))
  ) {
    return true;
  } else {
    return false;
  }
};

export const errorBirthYearBeneficiary = (date: any, birthYear: any) => {
  const year = new Date(date).getFullYear();
  return year != birthYear;
};

export const renderEditButtonTitle = (
  props: any,
  isManagerOpeningManager: any,
  victim: VictimType,
  isValidated: boolean,
  isRejected: boolean,
  value: any,
  isValidatedCorpo: boolean,
) => {
  return isManagerOpeningManager
    ? get(victim, 'decision.status', '') === 'PENDING'
      ? translate({ ...messages.decisionButtonTitle }, props)
      : !victim?.isFromSagis &&
        !props.isLockedPage &&
        !isValidatedCorpo &&
        shouldDisplayEditButton(
          props.isRecapPage,
          props.isManager,
          props.isReadOnly,
          value,
        )
      ? translate({ ...messages.updateBtnLabel }, props)
      : undefined
    : !victim?.isFromSagis &&
      !props.isLockedPage &&
      shouldDisplayEditButton(
        props.isRecapPage,
        props.isManager,
        props.isReadOnly,
        value,
        isRejected,
        props.isLawyer,
        props.isCourtManager,
      ) &&
      !isValidatedCorpo &&
      !(props.isOpeningManager && isRejected) &&
      (isValidated && props.isOpeningManager
        ? featureService.hasFeature(
            FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
          )
        : true) &&
      (props.isCourtManager
        ? featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER) ||
          featureService.hasFeature(FEATURES.UPDATE_VICTIM_BASIC_MANAGEMENT) ||
          featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)
        : true)
    ? translate({ ...messages.updateBtnLabel }, props)
    : undefined;
};

export const renderDeleteButtonTitle = (
  props: any,
  victim: VictimType,
  isRejected: boolean,
  isValidated: boolean,
  isValidatedCorpo: boolean,
) => {
  return !isVictimIncludedInJudiciarySteps(victim) &&
    !props.isCourtManagerBasicManagement &&
    !victim?.isFromSagis &&
    !isValidatedCorpo &&
    !(props.isOpeningManager && isRejected) &&
    !userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
    !userPrivileges.userHasPrivilege(PRIVILEGES.ISTRANSACTIONMANAGER) &&
    (isValidated && props.isOpeningManager
      ? featureService.hasFeature(
          FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
        )
      : true) &&
    (props.isCourtManager
      ? featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)
      : true) &&
    !props.isLockedPage
    ? translate(messages.delete, props)
    : undefined;
};
export const isManagerInTransactionInboxe = (transactionInboxeArea: any) => {
  const transactionInboxeAreaId = userPrivileges
    .getUserInboxes()
    .map((el: any) =>
      !isNil(el.transactionInboxeAreaId)
        ? el.transactionInboxeAreaId
        : undefined,
    )
    .filter((element: any) => element);
  return transactionInboxeAreaId.includes(transactionInboxeArea);
};
export const renderSwitchTransactionTitle = (
  props: any,
  isTransactionManager: boolean,
  victim: VictimType,
  victimsEligibleToTransaction: any,
) => {
  return isTransactionManager &&
    !props.isLockedPage &&
    !isEmpty(get(victim, 'victimKey', '')) &&
    !isNil(get(victim, 'victimKey', null)) &&
    isManagerInTransactionInboxe(
      get(props.transactionInboxeAreaId, 'transactionInboxeAreaId'),
    )
    ? isEmpty(get(victim, 'eligibilityTransaction', [])) &&
      isNil(
        get(
          victimsEligibleToTransaction.find(
            (el: any) => el.id === get(victim, 'id'),
          ),
          'eligible',
          null,
        ),
      ) &&
      isEmpty(get(victim, 'transactions', [])) &&
      !props.isLockedPage
      ? translate(messages.eligibilityButtonTitle, props)
      : !isEmpty(get(victim, 'eligibilityTransaction', [])) &&
        get(victim, 'eligibilityTransaction.[0].eligibility', false) &&
        !props.isLockedPage &&
        isEmpty(get(victim, 'transactions', []))
      ? translate(messages.switchTransactionTitle, props)
      : undefined
    : undefined;
};

export const checkTotalVictims = (
  totalInjuredVictims: Number,
  totalDeceasedVictims: Number,
  list: Array<any>,
) => {
  const injuredVictims = list.filter(
    victim => victim[VICTIM.INJURY_POST_KEY] === INJURY_POST_INJURED,
  );
  const deceasedVictims = list.filter(
    victim => victim[VICTIM.INJURY_POST_KEY] === INJURY_POST_DECEASED,
  );
  return (
    injuredVictims.length === totalInjuredVictims &&
    deceasedVictims.length === totalDeceasedVictims &&
    (injuredVictims.length === 0
      ? deceasedVictims.length > 0
      : injuredVictims.length > 0)
  );
};
export const victimConstraints = (
  _victim: any,
  isCourtBasicManagement?: boolean,
) => {
  return {
    [VICTIM.CIN]: isCourtBasicManagement
      ? { presence: true }
      : {
          presence: true,
          format: {
            pattern: /[A-Za-z]{1,2}\d{1,6}[A-Za-z]?|\d{1,7}[A-Za-z]/,
            message: messages.cinInvalid,
          },
        },
    [VICTIM.ADDRESS]: {
      presence: true,
    },
    [VICTIM.CITY]: {
      presence: true,
    },
    [VICTIM.CLASS_KEY]: {
      presence: true,
    },
    [VICTIM.DATE_OF_BIRTH]: {
      presence: true,
      format: {
        pattern: /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i,
        message: messages.invalidDate,
      },
    },
    [VICTIM.FIRST_NAME]: {
      presence: true,
    },
    [VICTIM.INJURY_POST_KEY]: {
      presence: true,
    },
    [VICTIM.IS_EXCLUDED]: {
      presence: featureService.hasFeature(
        FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE,
      ),
    },
    [VICTIM.LAST_NAME]: {
      presence: true,
    },
    [VICTIM.OPPOSITION]: {
      presence: true,
    },
    [VICTIM.PROCEDURE_ID]: {
      presence: true,
    },
    [VICTIM.PROFESSION]: {
      presence:
        String(get(_victim, [VICTIM.PROFESSION_TYPE])) === OTHER_PROFESSION,
    },
    [VICTIM.PROFESSION_TYPE]: {
      presence: true,
    },
    [VICTIM.QUALITY_KEY]: {
      presence: true,
    },
    [VICTIM.TELEPHONE_NUMBER]: isCourtBasicManagement
      ? { presence: true }
      : {
          presence: true,
          format: {
            pattern: /^\d{10}$/,
            message: messages.phoneNumberInvalid,
          },
        },
    [VICTIM.WORK_ACCIDENT_ID]: {
      presence: true,
    },
    [VICTIM.ITT_AVAILABILITY]: {
      presence: !INJURY_POST.DECEASED.includes(
        String(get(_victim, [VICTIM.INJURY_POST_KEY])),
      ),
    },
    [VICTIM.ITT]: {
      presence:
        !INJURY_POST.DECEASED.includes(
          String(get(_victim, [VICTIM.INJURY_POST_KEY])),
        ) &&
        String(get(_victim, [VICTIM.ITT_AVAILABILITY])) ===
          VICTIM_ITT_AVAILABILITY.AVAILABLE,
    },
    [VICTIM.GENDER]: {
      presence: INJURY_POST.DECEASED.includes(
        String(get(_victim, [VICTIM.INJURY_POST_KEY])),
      ),
    },
  };
};
export const victimValidator = (
  victim: VictimType,
  isCourtBasicManagement?: boolean,
) => {
  return validate(victim, victimConstraints(victim, isCourtBasicManagement));
};

export const victimsValidator = (
  victims: any,
  isCourtBasicManagement?: boolean,
) => {
  return victims.map((victim: any) => {
    const victimId = victim.id ? victim.id : victim.uniqueId;
    return {
      ...victimValidator(victim, isCourtBasicManagement),
      id: victimId,
    };
  });
};

export const formatUpdateFraudeInfo = (
  fraude: FraudInfoType,
  victims: VictimType[],
  vehicules: VehiculeType[],
  oldFraudeInfo: FraudInfoType,
  isOpeningManager: boolean,
) => {
  if (isOpeningManager) {
    return [
      {
        opposingLawyer: fraude?.opposingLawyer,
        comment: get(fraude, 'comment')
          ? get(fraude, 'comment')
          : get(oldFraudeInfo, 'fraudInfoMotif.[0].comment', []),
        fraudMotifs: isEmpty(get(fraude, 'fraudMotifs', []))
          ? get(oldFraudeInfo, 'fraudInfoMotif', []).map(
              (el: any) => el.motifId,
            )
          : get(fraude, 'fraudMotifs', []),
        decision: fraude?.decision
          ? {
              status: fraude?.decision?.status,
              decidedBy: fraude?.decision?.decidedBy,
              comment: fraude?.decision?.comment,
            }
          : {},
        updatedBy: currentUserStorage.get()?.username,
        victims: victims.filter((el: VictimType) =>
          get(fraude, 'victims', []).includes(el.cin),
        ),
        vehicules: vehicules.filter((el: VehiculeType) =>
          get(fraude, 'vehicules', []).includes(el.registrationNumber),
        ),
      },
    ];
  } else if (!isEmpty(oldFraudeInfo)) {
    return [
      oldFraudeInfo,
      {
        opposingLawyer: fraude?.opposingLawyer,
        comment: get(fraude, 'comment')
          ? get(fraude, 'comment')
          : get(oldFraudeInfo, 'fraudInfoMotif.[0].comment', []),
        fraudMotifs: isEmpty(get(fraude, 'fraudMotifs', []))
          ? get(oldFraudeInfo, 'fraudInfoMotif', []).map(
              (el: any) => el.motifId,
            )
          : get(fraude, 'fraudMotifs', []),
        decision: fraude?.decision
          ? {
              status: fraude?.decision?.status,
              decidedBy: fraude?.decision?.decidedBy,
              comment: fraude?.decision?.comment,
            }
          : {},
        updatedBy: currentUserStorage.get()?.username,
        victims: victims.filter((el: VictimType) =>
          get(fraude, 'victims', []).includes(el.cin),
        ),
        vehicules: vehicules.filter((el: VehiculeType) =>
          get(fraude, 'vehicules', []).includes(el.registrationNumber),
        ),
      },
    ];
  } else {
    return [
      {
        opposingLawyer: fraude?.opposingLawyer,
        comment: get(fraude, 'comment')
          ? get(fraude, 'comment')
          : get(oldFraudeInfo, 'fraudInfoMotif.[0].comment', null),
        fraudMotifs: isEmpty(get(fraude, 'fraudMotifs', []))
          ? get(oldFraudeInfo, 'fraudInfoMotif', []).map(
              (el: any) => el.motifId,
            )
          : get(fraude, 'fraudMotifs', []),
        decision: fraude?.decision
          ? {
              status: fraude?.decision?.status,
              decidedBy: fraude?.decision?.decidedBy,
              comment: fraude?.decision?.comment,
            }
          : {},
        updatedBy: currentUserStorage.get()?.username,
        victims: victims.filter((el: VictimType) =>
          get(fraude, 'victims', []).includes(el.cin),
        ),
        vehicules: vehicules.filter((el: VehiculeType) =>
          get(fraude, 'vehicules', []).includes(el.registrationNumber),
        ),
      },
    ];
  }
};

export const validatorFraudInfo = (fraudInfo: FraudInfoType) => {
  return (
    isNil(get(fraudInfo, 'opposingLawyer', null)) ||
    isEmpty(get(fraudInfo, 'opposingLawyer', null)) ||
    ((fraudInfo.fraudMotifs as any)?.size === 0 &&
      isEmpty(fraudInfo.fraudMotifs)) ||
    isEmpty(get(fraudInfo, 'victims', []))
  );
};

export const formatNextOfKinstoUpdate = (
  decisionVictim: any,
  beneficiary: BeneficiaryType,
  value: any,
  victim_index: number,
) => {
  if (decisionVictim) {
    return {
      ...beneficiary,
      updateDecisionVictim: decisionVictim,
      claimId: get(value, 'claim.id', ''),
      decisionVictim: {
        id: get(value.victims[victim_index], 'decision.id'),
        status: PARTIES_CLAIM_STATUS.PENDING,
        reason: null,
      },
      victimKey: get(value.victims[victim_index], 'victimKey'),
      ayantDroit: {
        fullName: `${removeWhiteSpaceFromString(
          beneficiary.firstName,
        )} ${removeWhiteSpaceFromString(beneficiary.lastName)}`,
        qualityCode: Number(beneficiary.beneficiaryType),
        age: Number(beneficiary.age),
        funeralFees: beneficiary.funeralFees,
        birthDate: beneficiary?.dateOfBirth,
        handicapIndicator: beneficiary.handicapIndicator ? 'Y' : 'N',
        dependentIndicator: beneficiary.dependentIndicator ? 'Y' : 'N',
        nextOfKinKey: !isNil(get(beneficiary, 'nextOfKinKey'))
          ? get(beneficiary, 'nextOfKinKey')
          : undefined,
      },
    };
  } else {
    return {
      ...beneficiary,
      updateDecisionVictim: decisionVictim,
      claimId: get(value, 'claim.id', ''),
      victimKey: get(value.victims[victim_index], 'victimKey'),
      ayantDroit: {
        fullName: `${removeWhiteSpaceFromString(
          beneficiary.firstName,
        )} ${removeWhiteSpaceFromString(beneficiary.lastName)}`,
        qualityCode: Number(beneficiary.beneficiaryType),
        age: Number(beneficiary.age),
        birthDate: beneficiary?.dateOfBirth,
        funeralFees: beneficiary.funeralFees,
        handicapIndicator: beneficiary.handicapIndicator ? 'Y' : 'N',
        dependentIndicator: beneficiary.dependentIndicator ? 'Y' : 'N',
        nextOfKinKey: !isNil(get(beneficiary, 'nextOfKinKey'))
          ? get(beneficiary, 'nextOfKinKey')
          : undefined,
      },
    };
  }
};

export const ShouldShowAddVictimButton = (
  isRejected: boolean,
  isPending: boolean,
  isValidated: boolean,
  isValidatedCorpo: boolean,
  isConversion?: boolean,
  isLawyer?: boolean,
  isLockedPage?: boolean,
  isCourtManager?: boolean,
) => {
  return (
    !isConversion &&
    ((isRejected &&
      featureService.hasFeature(FEATURES.LAWYER_REJECTED_CLAIM_UPDATE) &&
      isLawyer) ||
      (userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
        ((featureService.hasFeature(FEATURES.UPDATE_CLAIM_OPENING_MANAGER) &&
          isPending) ||
          (featureService.hasFeature(
            FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
          ) &&
            isValidated)) &&
        !isLockedPage &&
        !isValidatedCorpo) ||
      (isCourtManager &&
        featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)))
  );
};

export const displayButtonAddBeneficiary = (
  isRecapPage: boolean,
  isOpeningManager: boolean | undefined,
  isLawyer: boolean | undefined,
  isRejected: boolean,
  isLockedPage: boolean | undefined,
  isCourtManager: boolean | undefined,
  isValidated: boolean,
  isCourtManagerBasicManagement: boolean | undefined,
  isValidatedCorpo: boolean,
) => {
  return (
    (!isRecapPage ||
      isOpeningManager ||
      (isLawyer && isRejected && !isLockedPage) ||
      (isCourtManager &&
        featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER))) &&
    (isValidated && isOpeningManager
      ? featureService.hasFeature(
          FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
        )
      : true) &&
    !isCourtManagerBasicManagement &&
    !isValidatedCorpo
  );
};

export const displayEditBeneficiaryButton = (
  isRecapPage: boolean,
  isManager: boolean,
  isReadOnly: boolean,
  value: BeneficiaryType,
  isRejected: boolean,
  isLawyer: boolean | undefined,
  isCourtManager: boolean | undefined,
  isValidatedCorpo: boolean,
  isOpeningManager: boolean | undefined,
  isValidated: boolean,
  updateMessage: any,
) => {
  return shouldDisplayEditButton(
    isRecapPage,
    isManager,
    isReadOnly,
    value,
    isRejected,
    isLawyer,
    isCourtManager,
  ) &&
    !isValidatedCorpo &&
    (isValidated && isOpeningManager
      ? featureService.hasFeature(
          FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
        )
      : true) &&
    (isCourtManager
      ? featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER) ||
        featureService.hasFeature(FEATURES.UPDATE_VICTIM_BASIC_MANAGEMENT)
      : true)
    ? updateMessage
    : undefined;
};
